// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #f1f1f1;
  font-family: "Satoshi", sans-serif;
}

.faq-section {
  width: 100%;
  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);
  max-width: 800px;
  margin: 0 auto;
}

.faq-title {
  text-align: center;
  font-size: clamp(32px, 4vw, 44px);
  font-weight: 600;
  margin: 0 0 48px;
  color: #f1f1f1;
  line-height: 1.25;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.faq-item:hover {
  border-color: rgba(255, 255, 255, 0.16);
}

.faq-item:focus-within {
  border-color: rgba(204, 255, 0, 0.4);
  box-shadow: 0 0 0 1px rgba(204, 255, 0, 0.2);
}

.faq-question-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: "Satoshi", sans-serif;
  color: #f1f1f1;
  font-size: clamp(15px, 1.5vw, 17px);
  font-weight: 500;
  line-height: 1.4;
  transition: color 0.2s ease;
}

.faq-question-row:hover {
  color: #fff;
}

.faq-question-text {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 12px;
}

.faq-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(204, 255, 0, 0.12);
  color: #ccff00;
  transition: background 0.2s ease, color 0.2s ease;
}

.faq-question-row:hover .faq-icon,
.faq-question-row[aria-expanded="true"] .faq-icon {
  background: rgba(204, 255, 0, 0.2);
  color: #ccff00;
}

.faq-answer-wrap {
  overflow: hidden;
}

.faq-answer {
  padding: 0 24px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.faq-answer p,
.faq-answer-list {
  margin: 16px 0 0;
  padding: 0;
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.65;
  color: #a0a0a0;
}

.faq-answer-list {
  list-style: none;
}

.faq-answer-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
}

.faq-answer-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ccff00;
  font-weight: 700;
}

.faq-answer-list li:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/faq/faq.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,iDAAiD;AACnD;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".faq-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #f1f1f1;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.faq-section {\n  width: 100%;\n  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.faq-title {\n  text-align: center;\n  font-size: clamp(32px, 4vw, 44px);\n  font-weight: 600;\n  margin: 0 0 48px;\n  color: #f1f1f1;\n  line-height: 1.25;\n}\n\n.faq-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-item {\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.faq-item:hover {\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.faq-item:focus-within {\n  border-color: rgba(204, 255, 0, 0.4);\n  box-shadow: 0 0 0 1px rgba(204, 255, 0, 0.2);\n}\n\n.faq-question-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px 24px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-family: \"Satoshi\", sans-serif;\n  color: #f1f1f1;\n  font-size: clamp(15px, 1.5vw, 17px);\n  font-weight: 500;\n  line-height: 1.4;\n  transition: color 0.2s ease;\n}\n\n.faq-question-row:hover {\n  color: #fff;\n}\n\n.faq-question-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding-right: 12px;\n}\n\n.faq-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: rgba(204, 255, 0, 0.12);\n  color: #ccff00;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.faq-question-row:hover .faq-icon,\n.faq-question-row[aria-expanded=\"true\"] .faq-icon {\n  background: rgba(204, 255, 0, 0.2);\n  color: #ccff00;\n}\n\n.faq-answer-wrap {\n  overflow: hidden;\n}\n\n.faq-answer {\n  padding: 0 24px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.faq-answer p,\n.faq-answer-list {\n  margin: 16px 0 0;\n  padding: 0;\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.65;\n  color: #a0a0a0;\n}\n\n.faq-answer-list {\n  list-style: none;\n}\n\n.faq-answer-list li {\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 10px;\n}\n\n.faq-answer-list li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #ccff00;\n  font-weight: 700;\n}\n\n.faq-answer-list li:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
